import React, { useState } from "react";

let locations = [
  {
    id: "0",
    country: "USA",
    location:
      "Transforma Inc.2015 Lincoln HWY, Suite # 210,Edison, NJ 08817, USA.",
    phone: "+1 908 315 4177",
    iframe:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3032.811682605792!2d-74.39818741882583!3d40.52365329773767!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3c8104c3c63c5%3A0x234f3bd43a8ac4e4!2s2015%20Lincoln%20Hwy%20%23210%2C%20Edison%2C%20NJ%2008817%2C%20USA!5e0!3m2!1sen!2sin!4v1718970195029!5m2!1sen!2sin",
  },
  {
    id: "1",
    country: "GERMANY",
    location: "Linus-IT GmbHWilhelm-Schrohe-Straße 7255128 Mainz, Germany",
    phone: "+49 151 52534628",
    iframe:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2565.3211002608664!2d8.235096485378541!3d49.98658909804097!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bd96c68cbc0155%3A0x9799c7ddd1a22acb!2sWilhelm-Schrohe-Stra%C3%9Fe%2C%2055128%20Mainz%2C%20Germany!5e0!3m2!1sen!2sin!4v1718970323398!5m2!1sen!2sin",
  },
];

const Contactus = () => {
  const [currentItem, setCurrentItem] = useState(0);
  const [details, setDetails] = useState({
    name: "",
    lastname: "",
    email: "",
    telephone: "",
    textbox: "",
  });

  const handlechange = (e) => {
    let { name, value } = e.target;
    setDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlesubmit = (e) => {
    e.preventDefault();
    console.log(details);
  };

  return (
    <div className="flex justify-center text-left mb-20 md:mb-[120px]">
      <div className="2xl:container flex flex-col">
        <div className="contactbanner flex flex-col items-center">
          <div className="lg:p-20 p-4 w-full flex flex-col items-center">
            <div className="text-white mt-10 lg:mt-0 text-32 lg:text-56 font-semibold">
              Contact us
            </div>
            <div className="w-[5%] h-[3px] rounded-full bg-logoorange mt-5 lg:mt-10"></div>
            <div className=" mt-10 w-full lg:w-11/12 contactleft relative flex lg:flex-row flex-col-reverse">
              <div className="w-full lg:w-2/3 px-6 py-10 bg-white ">
                <h1 className="text-32 font-semibold ">Send us a message</h1>
                <form
                  onSubmit={handlesubmit}
                  className="flex flex-wrap mt-12 gap-[60px]"
                >
                  <input
                    type="text"
                    name="name"
                    id="firstname"
                    value={details.name}
                    onChange={handlechange}
                    className="w-full lg:w-[40%] h-8 border-b-[1px] border-border outline-none "
                    placeholder="First Name"
                  />
                  <input
                    type="text"
                    name="lastname"
                    value={details.lastname}
                    onChange={handlechange}
                    id="lastname"
                    className="w-full lg:w-[40%] h-8 border-b-[1px] border-border outline-none"
                    placeholder="Last Name"
                  />
                  <input
                    type="email"
                    name="email"
                    value={details.email}
                    onChange={handlechange}
                    id="email"
                    className="w-full lg:w-[40%] h-8 border-b-[1px] border-border outline-none"
                    placeholder="Email"
                  />
                  <input
                    type="tel"
                    name="telephone"
                    id="telephone"
                    value={details.telephone}
                    onChange={handlechange}
                    className="w-full lg:w-[40%] h-8 border-b-[1px] border-border outline-none"
                    placeholder="Phone Number"
                  />
                  <input
                    type="text"
                    name="textbox"
                    id="textbox"
                    value={details.textbox}
                    onChange={handlechange}
                    className="w-[100%] h-8 border-b-[1px] border-border outline-none"
                    placeholder="Leave your Message"
                  />
                  <div className="w-full flex justify-center mt-[60px]">
                    <button
                      type="submit"
                      className="bg-orange flex text-white items-center text-18 font-semibold px-[16.5px] py-6"
                    >
                      SEND MESSAGE{" "}
                      <span className="pl-6">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/contact/rightarrow.png"
                          }
                        />
                      </span>
                    </button>
                  </div>
                </form>
              </div>
              <div className="w-full lg:w-1/3 px-6 py-10 bg-contactgreen">
                <div className="flex flex-col gap-4">
                  <h1 className="text-white text-32 font-semibold">
                    Get in Touch
                  </h1>
                  <p className="text-18 text-white ">
                    Unlock the capabilities of our proprietary workflow
                    solutions to elevate your production process with top-tier
                    services
                  </p>
                </div>
                <div className="mt-14 gap-8 flex flex-col">
                  <p className="flex text-20 font-semibold text-white gap-6">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/images/contact/phoneicon.svg"
                        }
                      />
                    </span>
                    +91 44 4046 1222
                  </p>
                  <p className="flex text-20 font-semibold text-white gap-6">
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/images/contact/phoneicon.svg"
                        }
                      />
                    </span>
                    +1 908 315 4177
                  </p>
                  <p className="flex text-20 font-semibold text-white gap-6">
                    <span>
                      <img
                        // src={process.env.PUBLIC_URL + "/images/phoneicon.svg"}
                        src={process.env.PUBLIC_URL + "/images/contact/sms.svg"}
                      />
                    </span>
                    info@transforma.in
                  </p>
                  <div className="flex items-start gap-6">
                    <span className="text-[#9bfff1cc]">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-map-pin"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                        <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" />
                      </svg>
                    </span>
                    <div className={`flex flex-col gap-4  text-white`}>
                      <h1 className={`text-20 font-semibold`}>USA</h1>
                       <p className="text-16 lg:text-18 flex flex-col gap-2 ">
                        Transforma Inc.2015 Lincoln HWY, Suite # 210,Edison, NJ
                        08817, USA.
                        <span>+1 908 315 4177</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="w-full">
          <div className="p-4 lg:p-20">
            <h1 className="text-32 lg:text-46 w-full lg:w-2/5 font-semibold">
              Across the world assistance
            </h1>
          </div>
          <div className="mt-[20px] p-4 lg:p-6 relative">
            {locations.map(
              (i, index) =>
                currentItem === index && (
                  <iframe
                    key={index}
                    src={i.iframe}
                    width="100%"
                    height="560"
                    allowfullscreen=""
                    loading=""
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                )
            )}
            <button className="relative lg:absolute -top-[25%] lg:right-[10%] w-full lg:w-[35%] mt-10 lg:mt-0 bg-white p-2 lg:p-6 shadow-highlig locationfloat text-left">
              <h1 className="text-24 lg:text-32 font-medium text-primarycolor mt-8">
                Office Locations
              </h1>
              <div className="flex flex-col w-full gap-[6px] mt-[30px]">
                {locations.map((i, index) => (
                  <div
                    key={index}
                    onClick={() => setCurrentItem(index)}
                    className={`flex flex-col gap-4 ${
                      currentItem === index
                        ? "bg-location"
                        : "hover:border-[1px] hover:border-logoorange"
                    } p-[18px]`}
                  >
                    <h1
                      className={`text-18 lg:text-24 font-medium ${
                        currentItem === index ? "text-logoorange" : ""
                      }`}
                    >
                      {i.country}
                    </h1>
                    <p className="text-16 lg:text-18 text-secondaryblack">
                      {i.location}
                    </p>
                    <p className="text-16 lg:text-18 text-secondaryblack">
                      {i.phone}
                    </p>
                  </div>
                ))}
              </div>
            </button>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Contactus;
